import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/5.4.3/js/sparta-bootstrap-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.1.0/js/sparta-transport-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/4.0.4/js/sparta-messaging-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.3.5/js/sparta-require-utility";
import spartaExperienceUtility from "utilities/global/sparta-experience-utility/2.4.2/js/sparta-experience-utility";
import moduleContainer from "utilities/helpers/module-container/3.3.4/js/module-container";
import * as jcrUtility from "utilities/global/jcr-utility/1.2.3/js/jcr-utility";
import Communicator from "utilities/global/sparta-module-utility/7.2.0/js/communicator";
export default class View extends Communicator {
  constructor( options ) {
    super( options.settings );

    let defaults = {};

    this.settings = defaults;
    this.settings = $.extend(defaults, options.settings);

    this.model = options.model;

    this._initialize();
  }

  _initialize() {

  }

}